const ES = {
    title: 'Productos',
    subtitle: 'Producto', // se usa en submenu producto en detalles de cliente
    table: {
        title: 'Listado de Productos',
        columns: {
            accountNumber: 'N° Producto',
            client: 'Vendedor',
            dni: 'INE',
            description: 'Descripción',
            amount: 'Monto',
            createdAt: 'Fecha Creación',
            paymentDate: 'Último intento de pago',
            status: 'Estado',
            accountPosition: 'Posición producto'
        },
    }
};
export default ES;
